import { useCallback, useEffect, useMemo, useState } from "react";
import { post } from "../networking/RequestService";

function useGetCainNotifications(params = {}, autoFetch = true) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const memoizedParams = useMemo(() => params, [JSON.stringify(params)]);

    const fetchCainNotifications = useCallback(async () => {
        if (!loading) setLoading(true);
        setError(null);
        try {
            const response = await post({ fn: "getCainNotifications", ...memoizedParams });
            setData(response.data);
        } catch (error) {
            setError(error.response?.data?.text || "An unexpected error occurred");
        } finally {
            setLoading(false);
        }
    }, [memoizedParams]);

    useEffect(() => {
        if (autoFetch) {
            fetchCainNotifications();
        }
    }, [fetchCainNotifications, autoFetch]);

    return { data, loading, error, fetchCainNotifications };
}

export default useGetCainNotifications;
